import { createTheme } from '@mui/material'

export const DarktTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#34348A',
            dark: '#08085C',
            light: '#6B6BB0',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#FFB71B',
            dark: '#D99100',
            light: '#FFD36B',
            contrastText: '#08085C',
        },
        background: {
            default: "#202124",
            paper: "#303134"
        },
    },
    typography: {
        allVariants: {
            color: 'white',
        }
    }
});
